/* Vestigium · oferta de pack en el carrito (19/10/2026). Marcado: snippets/vg-oferta-carrito.liquid
   (cajón y página /cart). CSS: vestigium.css §20.
   Al pulsar «Cambiar a 2 kits»: /cart/add.js del pack con las mismas propiedades de personalización y,
   si va bien, /cart/change.js de la línea antigua a 0 pidiendo las secciones que repinta el propio tema
   (getSectionsToRender de cart-drawer-items y de cart-items), así el cajón y la burbuja del carrito se
   pintan una sola vez, al final. Si no se puede quitar la línea antigua, se deshace lo añadido.
   Mientras dura, la lista de líneas queda bloqueada como la bloquea el tema (.cart__items--disabled).
   No toca cart-drawer.js, cart.js ni vestigium-compra.js. */
(function () {
	'use strict';
	if (window.vgCarrito) return;
	window.vgCarrito = 1;
	var d = document, enCurso = false; // un cambio cada vez, aunque el tema repinte la tarjeta a mitad
	var POR_DEFECTO = [ // los del cajón de Zendrop, por si el tema aún no los diera
		{ id: 'CartDrawer', section: 'cart-drawer', selector: '.drawer__inner' },
		{ id: 'cart-icon-bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }
	];

	function quieto() { return matchMedia('(prefers-reduced-motion: reduce)').matches; }
	function ruta(k, def) { return ((window.routes || {})[k] || def) + '.js'; }
	function pide(url, cuerpo) {
		return fetch(url, {
			method: 'POST',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify(cuerpo)
		}).then(function (r) {
			return r.json().catch(function () { return {}; }).then(function (j) {
				if (!r.ok || !j || j.status || j.errors) throw j || {};
				return j;
			});
		});
	}

	// Las secciones que el tema repinta al cambiar el carrito (sin repetir y solo si están en la página;
	// la Section Rendering API admite 5 por petición)
	function secciones() {
		var lista = [], ids = {}, nombres = [];
		['cart-drawer-items', 'cart-items'].forEach(function (q) {
			var h = d.querySelector(q), s = [];
			try { s = h && h.getSectionsToRender ? h.getSectionsToRender() : []; } catch (e) { /* sin secciones */ }
			s.forEach(function (x) {
				if (!x || !x.section || ids[x.id] || !d.getElementById(x.id)) return;
				if (nombres.indexOf(x.section) < 0) {
					if (nombres.length >= 5) return;
					nombres.push(x.section);
				}
				ids[x.id] = 1;
				lista.push(x);
			});
		});
		return lista.length ? lista : POR_DEFECTO.filter(function (x) { return d.getElementById(x.id); });
	}
	function nombres(lista) {
		return lista.map(function (x) { return x.section; }).filter(function (s, i, a) { return a.indexOf(s) === i; });
	}
	function conSecciones(st, lista) {
		if (st && st.sections) return Promise.resolve(st);
		return fetch(location.pathname + '?sections=' + nombres(lista).join(',')).then(function (r) { return r.json(); })
			.then(function (s) { st = st || {}; st.sections = s; return st; });
	}
	// Igual que CartItems.updateQuantity: innerHTML del selector de cada sección
	function pinta(st, lista) {
		var n = 0;
		lista.forEach(function (x) {
			try {
				var h = st.sections && st.sections[x.section], el = d.getElementById(x.id), src;
				if (!h || !el) return;
				src = new DOMParser().parseFromString(h, 'text/html').querySelector(x.selector);
				if (!src) return;
				(el.querySelector(x.selector) || el).innerHTML = src.innerHTML;
				n++;
			} catch (e) { /* esa sección se queda como estaba */ }
		});
		return n;
	}

	// Avisos: el del cajón va en su región viva (el cajón es aria-modal). base.css esconde los <p> vacíos y
	// una región escondida no se lee: se muestra (sigue visualmente oculta) antes de escribir.
	function anuncia(r, t) {
		if (!r) return;
		r.style.display = 'block';
		r.removeAttribute('aria-hidden');
		r.textContent = '';
		setTimeout(function () { r.textContent = t; }, 120);
	}
	function aviso(o, t, mal) {
		var a = o && o.querySelector('.vg-oferta__aviso');
		if (!a) return;
		a.classList.toggle('is-vg-error', !!mal);
		a.textContent = t;
	}
	// Sin aria-busy en la tarjeta: contiene el aviso «Cambiando…» y los lectores lo callarían
	function ocupada(o, si) {
		var b = o.querySelector('[data-vg-oferta-cambiar]');
		o._vgOcupada = si;
		o.classList.toggle('is-vg-cargando', si);
		if (b) {
			if (si) b.setAttribute('aria-disabled', 'true');
			else b.removeAttribute('aria-disabled');
		}
	}
	// La lista de líneas, la misma que bloquea CartItems.enableLoading del tema (.cart__items--disabled,
	// pointer-events: none en component-cart.css): así «+», «−» y la papelera no se cruzan con el cambio
	function zona(cont) {
		return d.getElementById(cont.tagName === 'CART-DRAWER' ? 'CartDrawer-CartItems' : 'main-cart-items');
	}
	function bloquea(cont, si) {
		var z = zona(cont); // se vuelve a buscar: si se repintó, la nueva ya viene sin la clase
		if (z) z.classList.toggle('cart__items--disabled', si);
	}
	function enfoca(cont, el) {
		if (!el) return;
		if (cont.tagName === 'CART-DRAWER' && typeof trapFocus === 'function') trapFocus(cont, el);
		else el.focus();
	}

	function listo(cont, st, n, variante) {
		var dr = cont.tagName === 'CART-DRAWER', total = '';
		try { total = ' Total: ' + new Intl.NumberFormat('es-ES', { style: 'currency', currency: st.currency || 'EUR' }).format(st.total_price / 100) + '.'; } catch (e) { /* sin total */ }
		// El botón ya no existe: el foco va al nombre del producto, como hace el tema tras cambiar cantidades
		enfoca(cont, cont.querySelector('.cart-item__name'));
		Array.prototype.forEach.call(cont.querySelectorAll('.cart-item'), function (l) { l.classList.add('is-vg-cambiada'); });
		anuncia(d.getElementById(dr ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text'), 'Hecho: ahora tienes el pack de ' + n + ' kits.' + total);
		// Como CartItems.updateQuantity (source 'cart-items': el cajón no se vuelve a pedir)
		try { publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: st, variantId: variante }); } catch (e) { /* nada */ }
	}

	function fallo(cont, o, e, lista) {
		var x, b, t;
		if (e && e.vg === 'mixto') {
			// Se añadió el pack y no se pudo quitar ni el kit suelto ni el pack: se enseña el carrito tal cual
			t = 'Hemos añadido el pack, pero no hemos podido quitar el kit suelto. Si no lo quieres, quítalo con la papelera.';
			conSecciones(null, lista).then(function (st) { pinta(st, lista); }).catch(function () { /* nada */ }).then(function () {
				var er = d.getElementById(cont.tagName === 'CART-DRAWER' ? 'CartDrawer-CartErrors' : 'cart-errors');
				if (er) er.textContent = t;
				enfoca(cont, cont.querySelector('.cart-item__name'));
				anuncia(d.getElementById(cont.tagName === 'CART-DRAWER' ? 'CartDrawer-LiveRegionText' : 'cart-live-region-text'), t);
			});
			return;
		}
		x = cont.querySelector('.vg-oferta') || o;
		ocupada(x, false);
		aviso(x, 'Vaya, no hemos podido cambiarlo. Tu carrito sigue igual: inténtalo de nuevo.', true);
		b = x.querySelector('[data-vg-oferta-cambiar]');
		if (b && !o.isConnected) enfoca(cont, b); // la tarjeta se volvió a pintar: el foco no se pierde
	}

	function cambia(b) {
		var o = b.closest('.vg-oferta'), cont, z, lista, props, clave, n, variante, nueva;
		if (!o || o._vgOcupada || enCurso) return;
		cont = o.closest('cart-drawer') || o.closest('cart-items') || d.body;
		z = zona(cont);
		if (z && z.classList.contains('cart__items--disabled')) return; // el tema tiene un cambio en curso
		enCurso = true;
		try { props = JSON.parse(o.getAttribute('data-vg-oferta-propiedades') || '{}') || {}; } catch (e) { props = {}; }
		// Liquid da las propiedades como [[clave, valor], …]; /cart/add.js las quiere como objeto
		if (Array.isArray(props)) props = props.reduce(function (a, p) { if (p && p.length > 1) a[p[0]] = p[1]; return a; }, {});
		clave = o.getAttribute('data-vg-oferta-linea');
		n = o.getAttribute('data-vg-oferta-kits');
		variante = Number(o.getAttribute('data-vg-oferta-variante'));
		lista = secciones();
		ocupada(o, true);
		bloquea(cont, true);
		aviso(o, 'Cambiando al pack de ' + n + ' kits…');
		var cambio = { sections: nombres(lista), sections_url: location.pathname };
		pide(ruta('cart_add_url', '/cart/add'), { items: [{ id: variante, quantity: 1, properties: props }] })
			.then(function (r) {
				nueva = r && r.items && r.items[0] && r.items[0].key;
				return pide(ruta('cart_change_url', '/cart/change'), Object.assign({ id: clave, quantity: 0 }, cambio)).catch(function (e) {
					// No se pudo quitar el kit suelto: se deshace lo añadido para no cobrar de más
					if (!nueva) throw { vg: 'mixto' };
					return pide(ruta('cart_change_url', '/cart/change'), Object.assign({ id: nueva, quantity: 0 }, cambio)).then(function (st) {
						return conSecciones(st, lista).then(function (s) { pinta(s, lista); throw e; });
					}, function () { throw { vg: 'mixto' }; });
				});
			})
			.then(function (st) { return conSecciones(st, lista); })
			.then(function (st) {
				if (!pinta(st, lista)) return location.reload(); // el carrito cambió pero no se pudo repintar
				listo(cont, st, n, variante);
			})
			.catch(function (e) { fallo(cont, o, e, lista); })
			.then(function () { enCurso = false; bloquea(cont, false); });
	}

	d.addEventListener('click', function (e) {
		var b = e.target.closest && e.target.closest('[data-vg-oferta-cambiar]');
		if (!b) return;
		e.preventDefault();
		if (b.getAttribute('aria-disabled') !== 'true') cambia(b);
	});
	// Mientras dura el cambio, tampoco llega a «+», «−» ni a la papelera el «click» del teclado (Intro, espacio)
	d.addEventListener('click', function (e) {
		var l = enCurso && e.target.closest && e.target.closest('.cart-item');
		if (l && l.closest('.cart__items--disabled')) {
			e.preventDefault();
			e.stopPropagation();
		}
	}, true);

	// Entrada suave (y latido del sello) cuando la tarjeta se ve: al abrirse el cajón o al aparecer con él
	// abierto. El tema repinta el cajón dos veces seguidas al añadir (renderContents y onCartUpdate): con la
	// misma clave de oferta no se repite, sino que la tarjeta nueva sigue la entrada por donde iba
	// (--vg-ya, retraso negativo en vestigium.css §20) hasta que acaban la entrada y el latido (1,55 s).
	function revisa(c) {
		var o = c.querySelector('.vg-oferta'), k, t;
		if (c.tagName === 'CART-DRAWER' && !c.classList.contains('active')) {
			c._vgClave = null;
			if (o && o.classList.contains('is-vg-entra')) o.classList.remove('is-vg-entra');
			return;
		}
		if (!o) { c._vgClave = null; return; }
		k = o.getAttribute('data-vg-oferta-clave');
		if (k === c._vgClave) {
			t = performance.now() - (c._vgDesde || 0);
			if (!quieto() && t < 1600 && !o.classList.contains('is-vg-entra')) {
				o.style.setProperty('--vg-ya', -Math.round(t) + 'ms');
				o.classList.add('is-vg-entra');
			}
			return;
		}
		c._vgClave = k;
		c._vgDesde = performance.now();
		if (quieto()) return;
		o.style.removeProperty('--vg-ya');
		if (o.classList.contains('is-vg-entra')) {
			o.classList.remove('is-vg-entra');
			void o.offsetWidth;
		}
		o.classList.add('is-vg-entra');
	}
	function vigila() {
		['cart-drawer', 'cart-items'].forEach(function (q) {
			var c = d.querySelector(q), f;
			if (!c || c._vgOferta || !window.MutationObserver) return;
			c._vgOferta = 1;
			f = function () { revisa(c); };
			new MutationObserver(f).observe(c, { childList: true, subtree: true });
			new MutationObserver(f).observe(c, { attributes: true, attributeFilter: ['class'] });
			f();
		});
	}
	if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', vigila);
	else vigila();
})();
